export const PluralizeText = ({ count, singularText, pluralText = 's' }) => {
  if (count > 1) {
    return `${count} ${singularText + pluralText}`;
  }
  return `${count} ${singularText}`;
};
